import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".site-avatar-edit,.site-about-edit,.site-title-edit";

export default function loadEditLogo(context) {
    loadModuleOnElement(selector, loader, context, true);
    return context;
}
